/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from "react";
import { RouteComponentProps } from "@reach/router";
import Post from "./Post/Post";

// #region Componets
import Layout from "../../components/layout";
import SideBarRight from "./SideBarRight/SideBarRight";
import BasePureComponet from "../../components/Base/BasePureComponet";
// #endregion Componets

// Style
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import "./Doctor.scss";

interface DoctorProp extends RouteComponentProps {
  title: string;
}

class Doctor extends BasePureComponet<DoctorProp> {
  render() {
    return (
      <Layout title={this.props.title}>
        <MDBContainer fluid className="h-100 doctor-page">
          <MDBRow className="w-100 h-100 mx-0">
            <MDBCol className="h-100 order-md-1 order-1" md={"3"}>
              <SideBarRight />
            </MDBCol>
            <MDBCol className="h-100 order-md-2 doctor order-3 pb-5" md={"9"}>
              <Post />
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </Layout>
    );
  }
}
export default Doctor;
